/* eslint-disable max-len */
import React from "react";
import {PublicRoute} from "./enum";
import {addRouteComponent} from "../helpers/addRouteComponent";
import {Switch} from "react-router-dom";
import {Routes} from "../helpers/Routes";
import PublicRouteInfo from "./info";
import {ConnectedRouter} from "connected-react-router";
import App from "../../containers/App/App";
import {RestrictedRoute} from "../helpers/RestrictedRoute";
import {connect} from "react-redux";

function getPublicComponent(routeId) {
    switch (routeId) {
        case PublicRoute.Page500:
            return () => import('../../containers/Page/500');
        case PublicRoute.ContactMyinvoisData:
            return () => import('../../containers/Page/ContactMyinvoisData');
        case PublicRoute.SignIn:
            return () => import('../../containers/Page/signin');
        case PublicRoute.Invite:
            return () => import('../../containers/Page/Invite');
        case PublicRoute.SignUp:
            return () => import('../../containers/Page/SignUp');
        case PublicRoute.Activate:
            return () => import('../../containers/Page/Activate');
        case PublicRoute.ForgotPassword:
            return () => import('../../containers/Page/forgotPassword');
        case PublicRoute.TransactionView:
            return () => import('../../containers/Page/TransactionView');
        case PublicRoute.TransactionViewV2:
            return () => import('../../containers/Page/TransactionViewV2');
        case PublicRoute.TransactionViewV3:
        case PublicRoute.TransactionViewV3ShortLink:
            return () => import('../../containers/Page/TransactionViewV3');
        case PublicRoute.MiniPosOrderView:
            return () => import('../../containers/Page/MiniPosOrderView');
        case PublicRoute.StatementView:
            return () => import('../../containers/Page/StatementView');
        case PublicRoute.StatementViewV2:
            return () => import('../../containers/Page/StatementViewV2');
        case PublicRoute.NoPreview:
            return () => import('../../containers/Page/NoPreview');
        case PublicRoute.NoPreviewIframe:
            return () => import('../../containers/Page/NoPreviewIframe');
        case PublicRoute.PriceAdjustment:
            return () => import('../../components/PriceAdjustment');
        case PublicRoute.Page404:
        default:
            return () => import('../../containers/Page/404');
    }
}

const routes = addRouteComponent(PublicRouteInfo, getPublicComponent);

function PublicRouter(props) {
    const { history, isLoggedIn } = props;
    return (
        <ConnectedRouter history={history}>
            <Switch>
                { Routes(routes) }
                <RestrictedRoute component={App} isLoggedIn={isLoggedIn} />
            </Switch>
        </ConnectedRouter>
    );
}

export default connect(state => ({
    isLoggedIn: state.Auth.accessToken !== null,
}))(PublicRouter);
